import Splide from "@splidejs/splide";


document.addEventListener("DOMContentLoaded", function () {
  const testimonialsSlider = document.getElementById("testimonials-slider");


  if (testimonialsSlider) {
    const testimonialSlider = new Splide(testimonialsSlider, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      focus: "center",
      arrows: false,
      pagination: false,
      mediaQuery: "min",
      breakpoints: {
        1440: {
          gap: '32px',
          padding: "29%",
          trimSpace: false,
        },
      },
    }).mount();


    document.getElementById('prev').addEventListener('click', () => {
      testimonialSlider.go('<');
    });
    
    document.getElementById('next').addEventListener('click', () => {
      testimonialSlider.go('>'); 
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') testimonialSlider.go('<');
      if (e.key === 'ArrowRight') testimonialSlider.go('>');
    });
  }


});